export const USER_ID_SESSION_STORAGE = 'userId';

export const JWT_SESSION_STORAGE = 'jwt';

export const OTP_SESSION_STORAGE = 'otp';

export const ORG_SESSION_STORAGE = 'org';

export const USER_INFO_SESSION_STORAGE = 'userInfo';

export const ORG_INFO_SESSION_STORAGE = 'orgInfo';

export const BD_R_ORGANIZATION = 'BD_R_ORGANIZATION';

export const CUSTOM_FORMAT = 'Custom Format';

export const CUSTOM_IMPORT = 'Custom Import';

export const EMPTY_STRING = '';

export const EMPTY_ARRAY = [];

export const EMPTY_ARRAY_STRING = [''];

export const INITIAL_PAGE_STATE = {
	page: 1,
	perPage: 20,
	totalEntries: 0,
};

export const INITIAL_SORT_COLUMN_DESC = {
	id: 1,
	isAscending: false,
};

export const INITIAL_SORT_COLUMN_ASC = {
	id: 1,
	isAscending: true,
};

export enum TABS {
	IMPORT_HISTORY = 0,
	SAVED_TEMPLATE = 1,
}
